function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { groupBy } from 'lodash';
import { FieldSectionSubType } from 'api/field-sections/types';
import { HttpClient } from 'api/http-client';
export const RATING_SCALE = [
    3,
    5,
    7,
    10
];
function getUrl(fieldId) {
    return `/fields/${fieldId}`;
}
const addIndexToFieldsGroupedByObjectType = (accountFields)=>{
    return accountFields.map((accountField)=>{
        var _accountField_fields;
        const sortedFields = (_accountField_fields = accountField.fields) === null || _accountField_fields === void 0 ? void 0 : _accountField_fields.sort(({ fieldId: fieldIdA }, { fieldId: fieldIdB })=>fieldIdA - fieldIdB);
        /**
     * Doing special handling for INVOICE_PROJECT fields because
     * BE populates the fieldAccessMeta in PROJECT instead of INVOICE_PROJECT for these fields.
     * So even we have to populate index for it in PROJECT.
     */ const fieldsGrouped = groupBy(sortedFields, (field)=>field.objectSubType && field.objectSubType !== FieldSectionSubType.Default && field.objectSubType !== FieldSectionSubType.InvoiceProject ? field.objectSubType : field.objectType);
        accountField.fields = Object.values(fieldsGrouped).reduce((allFields, fieldsInGroup)=>allFields.concat(fieldsInGroup.map((field, index)=>({
                    ...field,
                    fieldIndex: index
                }))), []);
        return accountField;
    });
};
export var FieldsObjectTypeForApi = /*#__PURE__*/ function(FieldsObjectTypeForApi) {
    FieldsObjectTypeForApi["Tasks"] = "tasks";
    FieldsObjectTypeForApi["Projects"] = "projects";
    FieldsObjectTypeForApi["Expense"] = "expense";
    FieldsObjectTypeForApi["Invoice"] = "invoice";
    FieldsObjectTypeForApi["CreditNote"] = "credit-note";
    FieldsObjectTypeForApi["Users"] = "users";
    FieldsObjectTypeForApi["TimeEntry"] = "time-entry";
    FieldsObjectTypeForApi["Company"] = "company";
    FieldsObjectTypeForApi["Sprint"] = "sprint";
    FieldsObjectTypeForApi["Epic"] = "epic";
    FieldsObjectTypeForApi["Backlog"] = "backlog";
    FieldsObjectTypeForApi["Sheet"] = "sheet";
    FieldsObjectTypeForApi["Intervals"] = "intervals";
    FieldsObjectTypeForApi["KeyEvents"] = "key-events";
    FieldsObjectTypeForApi["ProjectPhase"] = "projectPhases";
    FieldsObjectTypeForApi["Reports"] = "reports";
    FieldsObjectTypeForApi["Financial"] = "financial";
    FieldsObjectTypeForApi["Budget"] = "projectFinancialsBudget";
    FieldsObjectTypeForApi["Timeoff"] = "time-off";
    FieldsObjectTypeForApi["ResourceAllocation"] = "resource-allocation";
    return FieldsObjectTypeForApi;
}({});
export var FieldSectionSubTypeForApi = /*#__PURE__*/ function(FieldSectionSubTypeForApi) {
    FieldSectionSubTypeForApi["Default"] = "DEFAULT";
    FieldSectionSubTypeForApi["Skill"] = "SKILL";
    FieldSectionSubTypeForApi["ExternalUser"] = "EXTERNAL_TEAM_MEMBER";
    FieldSectionSubTypeForApi["InvoiceProject"] = "INVOICE_PROJECT";
    FieldSectionSubTypeForApi["CustomerUser"] = "CUSTOMER_USER";
    return FieldSectionSubTypeForApi;
}({});
class FieldsHttpClient extends HttpClient {
    async updateField(fieldId, data) {
        return this.put(getUrl(fieldId), data);
    }
    async getField(fieldId) {
        return this.get(getUrl(fieldId));
    }
    async deleteField(fieldId) {
        return this.delete(getUrl(fieldId));
    }
    async createField(data) {
        return this.post('/fields', data);
    }
    async getFieldProjectMapping(fieldId, value) {
        return this.get(`${getUrl(fieldId)}/getIsStatusDeletePossible?value=${value}`);
    }
    async getFieldsByObjectType(objectType, objectSubType = "DEFAULT", ignoreIndexing = false) {
        var _addIndexToFieldsGroupedByObjectType;
        const query = `?objectSubType=${objectSubType}`;
        const resp = await this.get(`/${objectType}/fields${query}`);
        return ignoreIndexing ? resp : (_addIndexToFieldsGroupedByObjectType = addIndexToFieldsGroupedByObjectType([
            resp
        ])) === null || _addIndexToFieldsGroupedByObjectType === void 0 ? void 0 : _addIndexToFieldsGroupedByObjectType[0];
    }
    constructor(...args){
        super(...args), _define_property(this, "getAllFields", async ()=>{
            const data = await this.get('/all-fields');
            return addIndexToFieldsGroupedByObjectType(data);
        }), _define_property(this, "getSkillFieldIdsForReadAccess", async (resource)=>{
            return this.get(`/skill/fields${resource ? `?resource=${resource}` : ''}`);
        }), _define_property(this, "getTimeEntryFields", async ()=>{
            return this.get('/time-entry/fields').then((data)=>{
                return data.fields;
            });
        }), _define_property(this, "getExpenseFields", async ()=>{
            return this.get('/expense/fields').then((data)=>{
                return data.fields;
            });
        }), _define_property(this, "getPaginatedFields", async (objectType, args, resource)=>{
            const { includedFieldTypes, ...restArgs } = args !== null && args !== void 0 ? args : {};
            const bodyParams = {
                objectType,
                ...restArgs,
                resource
            };
            const config = (includedFieldTypes === null || includedFieldTypes === void 0 ? void 0 : includedFieldTypes.length) ? {
                params: {
                    includedFieldTypes: includedFieldTypes.join(',')
                }
            } : undefined;
            return this.post('/fields/searchLight', bodyParams, config);
        });
    }
}
export const FieldsAPI = new FieldsHttpClient();
